module.exports = __webpack_public_path__ + "img/eight5Orange.4a58fb51.jpg";